import { component } from 'picoapp'
import $ from 'quantdom'
import { getOutOfStockData } from '../lib/utils'

export default component((node) => {
  let atcPosition = document.querySelector('#AddToCart').offsetTop
  const featuredProductImages = $('#product-featured-image-container').find('[data-scroll-track]')
  const featuredProductImagesPosition = featuredProductImages.offsetHeight + featuredProductImages.offsetTop

  const positionGorgiasChatButton = () => {
    if (gorgiasChat) {
      if ($('#chat-button').els.length > 0) {
        if (typeof LoopOnstore !== 'undefined' && LoopOnstore?.isActive() === true) {
          $('#loop-onstore').addClass('js-sticky-active')
          $('#chat-button')
            .addClass('!tw-bottom-[165px]')
            .addClass('md:!tw-bottom-[75px]')
            .removeClass('js-sticky-inactive')
            .removeClass('!tw-bottom-[75px]')
        } else {
          $('#chat-button').addClass('!tw-bottom-[105px]').addClass('md:!tw-bottom-0')
        }
      } else {
        setTimeout(() => {
          positionGorgiasChatButton()
        }, 500)
      }
    }
  }

  const positionTop = () => {
    // get height of .js-header-container and stick ATC to bottom of header
    const headerHeight = document.querySelector('.js-header-container').offsetHeight
    if (window.innerWidth >= 768) {
      $(node).css('top', `${headerHeight}px`)
    } else {
      $(node).css('top', 'auto')
    }
  }

  function setHiddenState(newState) {
    $(node).attr('aria-hidden', newState)
  }

  // Add extra padding to bottom of page to account for sticky ATC
  $('body').addClass('tw-pb-[84px]').addClass('md:tw-pb-[0px]')

  // IntersectionObserver to show/hide sticky ATC
  const element = document.querySelector('#AddToCart')
  const intersectionCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setHiddenState(true)
        if (typeof LoopOnstore !== 'undefined' && LoopOnstore?.isActive() === true) {
          $('#chat-button')
            ?.removeClass('!tw-bottom-[165px]')
            .addClass('!tw-bottom-[75px]')
            .removeClass('js-sticky-inactive')
          $('#loop-onstore')?.removeClass('js-sticky-active')
        } else {
          $('#chat-button')?.removeClass('!tw-bottom-[105px]')
        }
        positionTop()
        removeEventListener('scroll', handleScroll, true)
      } else if (window.scrollY > atcPosition && !entry.isIntersecting) {
        setHiddenState(false)
        positionGorgiasChatButton()
        positionTop()
      }
    })
  }

  const observerOptions = {
    root: null,
    rootMargin: window.innerWidth < 768 ? '-10px 0px 0px 0px' : '-45px 0px 0px 0px',
    threshold: 0.7,
  }

  let observer = new IntersectionObserver(intersectionCallback, observerOptions)

  observer.observe(element)

  // Check for initial scroll past the atc button
  const handleScroll = () => {
    if (
      (window.scrollY > atcPosition && window.innerWidth < 768) ||
      (window.scrollY > featuredProductImagesPosition && window.innerWidth >= 768)
    ) {
      setHiddenState(false)
      positionGorgiasChatButton()
      positionTop()
      removeEventListener('scroll', handleScroll, true)
    }
  }
  addEventListener('scroll', handleScroll, true)

  // Listen for product:html-replaced (prenatal/hydration variant change) event to re-observe the atc button
  window.MicroBus.on(`product:html-replaced`, (e) => {
    observer.unobserve(element)
    observer.observe(document.querySelector('#AddToCart'))
  })

  window.MicroBus.on(`product:change`, (e) => {
    const { product, name } = e.detail
    const reviews = $(node).findEl('.stamped-product-reviews-badge')
    const productTitle = $(node).findEl('.js-sticky-atc-variant-text')
    const outOfStock = getOutOfStockData(product.variants[0].id)
    const atcButtons = $('.js-current-variant-id')

    if (product.title.startsWith('Hydration')) $(productTitle).text(product.title)

    if (outOfStock) {
      atcButtons.each((atcButton) => atcButton.setAttribute('out-of-stock', ''))
      atcButtons.each((atcButton) => atcButton.setAttribute('klaviyo-form-id', outOfStock.formId))
      atcButtons.each((atcButton) => atcButton.setAttribute('disable-cart-toggle', ''))
    } else {
      atcButtons.each((atcButton) => atcButton.removeAttribute('out-of-stock'))
      atcButtons.each((atcButton) => atcButton.removeAttribute('klaviyo-form-id'))
      atcButtons.each((atcButton) => atcButton.removeAttribute('disable-cart-toggle'))
    }

    $('.js-atc-text').html(
      `${outOfStock ? `${outOfStock.buttonText ? outOfStock.buttonText : 'Notify Me When Back In Stock'}` : 'Add to Cart'}`
    )

    $(reviews).attr('data-id', product.id)
    $(reviews).attr('data-product-title', name)
  })

  window.addEventListener('resize', () => {
    positionTop()
  })
})
